import {Grid, Link as MUILink, ListItem, makeStyles, Typography} from '@material-ui/core';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {MeterIcon} from './MeterIcon';
import { Check } from '@material-ui/icons';
import {Alert} from '@material-ui/lab';
import moment from 'moment';

const useStyles = makeStyles(() => ({
  root: {
    padding: '16px 16px',
    borderBottom: '1px solid grey',
    '&:hover': {
      backgroundColor: '#2c406080',
    },
    '&.MuiListItem-root.Mui-selected, &.MuiListItem-root.Mui-selected:hover': {
      backgroundColor: '#5f69a48a',
    },
  },
  typographyItem: {
    marginBottom: '8px',
  },
}));

function CalculateDailyUsage(readings) {
  const withDailyUsage = readings
  .sort((a, b) => moment(a.time).diff(moment(b.time))) // ensure time order
  .filter((r) => !r.deleted)
  .map((item, i, arr) => {
    if (i === 0) {
      return { ...item, dailyUsage: null }; // no previous point
    }

    const prev = arr[i - 1];
    const currentTime = moment(item.time);
    const prevTime = moment(prev.time);

    const hoursDiff = currentTime.diff(prevTime, "hours", true); // true = floating point
    const valueDiff = item.value - prev.value;

    // normalize to 24h rate
    const dailyUsage = (valueDiff / hoursDiff) * 24;

    return { ...item, dailyUsage };
  });
  return withDailyUsage;
}

function CheckForBadReadings(meter) {
  const {expectedUsage, readings} = meter;
  const readingsWithUsage = CalculateDailyUsage(readings);
  let negativeReading = 0;
  let largeReading = 0;
  let smallReading = 0;
  let extraBaselineError = 0;
  let tooFewBaselineError = 0;

  if (readingsWithUsage.length > 1) {
    negativeReading = readingsWithUsage.some(r => r.rawUsage < 0);
  }

  if (readingsWithUsage.filter((r) => !r.deleted).length > 1) {
    largeReading = readingsWithUsage.slice(1).some(r => r.dailyUsage > expectedUsage * 10);
    smallReading = readingsWithUsage.slice(1).some(r => r.dailyUsage < expectedUsage / 10);

    // if (meter.experimentStart)
    // extraBaselineError = readingsWithUsage.filter(r => r.time < )
  }

  //

  if (negativeReading) {
   return "Negative Reading";
  }

  if (largeReading || smallReading) {
   return "Extreme Reading";
  }
  return 0;
}

export function SideBarMeterListItem({meter, activeItem, setActiveItem}) {
  const {root, typographyItem} = useStyles();
  const {_id, name, unit, readings} = meter;
  let safeUnit = unit ? `Unit: ${unit}` : 'Unit:  - -';
  let badReadingsDetected = CheckForBadReadings(meter);

  const handleItemClick = (e) => {
    setActiveItem(_id);
  };

  return (
    <ListItem
      classes={{
        root: root,
      }}
      button
      component={RouterLink}
      to={`/${_id}`}
      key={_id}
      selected={activeItem === _id}
      onClick={handleItemClick}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={2}
      >
        <Grid item xs container direction="column">
          <Grid item classes={{root: typographyItem}} xs>
            <Typography variant="body2">
              {meter.username ? meter.username : 'Classmate'}
            </Typography>
          </Grid>
          <Grid item xs container direction="row">
            <Grid item container alignItems="center" direction="row" xs>
              <MeterIcon meter={meter} />
              <Typography variant="body2">{name}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs container alignContent="flex-end" direction="column">
          <Grid item xs>
            <Typography gutterBottom variant="body2" /> {safeUnit}
            <Typography variant="body2" gutterBottom>
              {`Readings: ${
                readings.length > 0
                  ? readings.reduce((count, reading) => {
                      return reading.deleted ? count : count + 1;
                    }, 0)
                  : 0
              }`}
            </Typography>
          </Grid>
        </Grid>
        {badReadingsDetected ?
        <Grid item container alignContent="center" xs={12}>
          <Alert severity="error">
            {badReadingsDetected}:{' '}
            <MUILink
              target="_blank"
              href="https://meterhero.com/fix"
              rel="noopener noreferrer"
              aria-label="Fix errors (opens in new window)"
              style={{ fontWeight: 'bold', color: '#a40000', textDecoration: 'underline' }}
              onClick={(e) => e.stopPropagation()}>
                Fix it
            </MUILink>
          </Alert>
        </Grid>
        : ``}
      </Grid>
    </ListItem>
  );
}
